import React, {useState} from 'react'
import { Grid } from '@material-ui/core'
import DisplayText from '../../../../../../components/Texts/DisplayText'
import CircularButton from '../../../../../../components/Buttons/CircularButton'
import VehicleTable from '../VehicleTable/VehicleTable'
import AddRegisterModal from '../../modals/AddRegisterModal'

const  Vehicle = props => {

    const {vehicles, onUpdateCollection} = props
    const [registerModal, setRegisterModal] = useState(false)


    const getRandomInt = (max) => {
        return Math.floor(Math.random() * Math.floor(max));
    }

    const onAddItem = (form) => {
            let temp = [...vehicles]
            let idx
            let isRepeated = true
            while(isRepeated){
                idx = getRandomInt(100)
                const filterItem = temp.filter(el => el.id === idx)
                if(filterItem.length === 0) isRepeated = false 
            }
            const data2send = {id:idx, name: form.name.value, car_type_id: form.type_id.value, car_range_id: form.car_range_id.value}
            console.log(data2send)
            temp.push(data2send)
            onUpdateCollection('vehicles', temp)
            setRegisterModal(false)

    }

    const onRemoveItem = (item) => {
        console.log(item)
        let newset = vehicles.filter(e => e.id !== item.id)
        onUpdateCollection('vehicles', newset)
    }

    return(
        <div>
            <AddRegisterModal open={registerModal} onAddItem={onAddItem}
            onClose={() => setRegisterModal(false)}/>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item>
                            <DisplayText variant='subtitle1'>Vehículos</DisplayText>
                        </Grid>
                        <Grid item>
                            <CircularButton icon='add' size='small' onClick={() => setRegisterModal(true)}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div >
                        <VehicleTable data={vehicles} onRemoveItem={onRemoveItem}/>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default Vehicle

